<template>
    <v-container fluid>
        <v-row dense>
            <v-col cols="4" />
            <v-col cols="2" class="offerTitleBackground">
                <v-sheet class="d-flex justify-center align-center basicOfferTitle">
                    STANDARD
                </v-sheet>
            </v-col>
            <v-col cols="2" class="offerTitleBackground">
                <v-sheet class="d-flex justify-center align-center essentialOfferTitle">
                    ESSENTIEL
                </v-sheet>
            </v-col>
            <v-col cols="2" class="offerTitleBackground">
                <v-sheet class="d-flex justify-center align-center premiumOfferTitle">
                    PREMIUM
                </v-sheet>
            </v-col>
            <v-col cols="2" class="offerTitleBackground">
                <v-tooltip>
                    <template #activator="{ props }">
                        <v-sheet
                            v-bind="props"
                            class="d-flex justify-center align-center premiumOfferTitle"
                        >
                            TRAINING*
                        </v-sheet>
                    </template>
                    <span>
                        {{ $t("training-text.description-text") }}
                    </span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row
            :style="{ 'overflow-y': 'auto', 'max-height': heightMax, 'overflow-x': 'hidden' }"
            dense
        >
            <v-col cols="12">
                <template v-for="(category, categories_index) in scheme" :key="categories_index">
                    <v-row dense>
                        <v-col cols="4">
                            <v-sheet class="titleCategory"> {{ category.title }}</v-sheet>
                        </v-col>

                        <v-col
                            cols="2"
                            v-if="category.basicOffer && category.basicOffer.colorised"
                            class="pt-0 pb-0"
                        >
                            <div class="basicOfferBackground ml-2"></div>
                        </v-col>
                        <v-col cols="2" v-else />

                        <v-col
                            cols="2"
                            v-if="category.essentialOffer && category.essentialOffer.colorised"
                            class="pt-0 pb-0"
                        >
                            <div class="essentialOfferBackground ml-2"></div>
                        </v-col>
                        <v-col cols="2" v-else />

                        <v-col
                            cols="2"
                            v-if="category.premiumOffer && category.premiumOffer.colorised"
                            class="pt-0 pb-0"
                        >
                            <div class="premiumOfferBackground ml-2"></div>
                        </v-col>
                        <v-col cols="2" v-else />
                        <v-col
                            cols="2"
                            v-if="category.trainingOffer && category.trainingOffer.colorised"
                            class="pt-0 pb-0"
                        >
                            <div class="essentialOfferBackground ml-2"></div>
                        </v-col>
                        <v-col cols="2" v-else />
                    </v-row>
                    <v-row
                        v-for="(subCategory, index) in category.categories"
                        :key="categories_index * 10000 + (index + 1)"
                        dense
                    >

                        <v-col cols="4">
                            <v-sheet class="titleSubCategory">{{ subCategory.title }}</v-sheet>
                        </v-col>

                        <v-col
                            cols="2"
                            v-if="
                                subCategory.basicOffer &&
                                subCategory.basicOffer.colorised &&
                                subCategory.basicOffer.isEnd
                            "
                            class="pt-0 pb-0"
                        >
                            <div class="basicOfferEndBackground d-flex justify-center ml-2">
                                <v-icon
                                    v-if="subCategory.basicOffer && subCategory.basicOffer.valid"
                                    class="basicOfferIcon"
                                >
                                    {{ subCategory.basicOffer.icon }}
                                </v-icon>
                            </div>
                        </v-col>
                        <v-col
                            cols="2"
                            v-else-if="subCategory.basicOffer && subCategory.basicOffer.colorised"
                            class="pt-0 pb-0"
                        >
                            <div class="basicOfferBackground d-flex justify-center ml-2">
                                <v-icon
                                    v-if="subCategory.basicOffer && subCategory.basicOffer.valid"
                                    class="basicOfferIcon"
                                >
                                    {{ subCategory.basicOffer.icon }}
                                </v-icon>
                            </div>
                        </v-col>
                        <v-col cols="2" v-else />

                        <v-col
                            cols="2"
                            v-if="
                                subCategory.essentialOffer &&
                                subCategory.essentialOffer.colorised &&
                                subCategory.essentialOffer.isEnd
                            "
                            class="pt-0 pb-0"
                        >
                            <div class="essentialOfferEndBackground d-flex justify-center ml-2">
                                <v-icon
                                    v-if="
                                        subCategory.essentialOffer &&
                                        subCategory.essentialOffer.valid
                                    "
                                    class="essentialOfferIcon"
                                >
                                    {{ subCategory.essentialOffer.icon }}
                                </v-icon>
                            </div>
                        </v-col>
                        <v-col
                            cols="2"
                            v-else-if="
                                subCategory.essentialOffer && subCategory.essentialOffer.colorised
                            "
                            class="pt-0 pb-0"
                        >
                            <div class="essentialOfferBackground d-flex justify-center ml-2">
                                <v-icon
                                    v-if="
                                        subCategory.essentialOffer &&
                                        subCategory.essentialOffer.valid
                                    "
                                    class="essentialOfferIcon"
                                >
                                    {{ subCategory.essentialOffer.icon }}
                                </v-icon>
                            </div>
                        </v-col>
                        <v-col cols="2" v-else />

                        <v-col
                            cols="2"
                            v-if="
                                subCategory.premiumOffer &&
                                subCategory.premiumOffer.colorised &&
                                subCategory.premiumOffer.isEnd
                            "
                            class="pt-0 pb-0"
                        >
                            <div class="premiumOfferEndBackground d-flex justify-center ml-2">
                                <v-icon
                                    v-if="
                                        subCategory.premiumOffer && subCategory.premiumOffer.valid
                                    "
                                    class="premiumOfferIcon"
                                >
                                    {{ subCategory.premiumOffer.icon }}
                                </v-icon>
                            </div>
                        </v-col>
                        <v-col
                            cols="2"
                            v-else-if="
                                subCategory.premiumOffer && subCategory.premiumOffer.colorised
                            "
                            class="pt-0 pb-0"
                        >
                            <div class="premiumOfferBackground d-flex justify-center ml-2">
                                <v-icon
                                    v-if="
                                        subCategory.premiumOffer && subCategory.premiumOffer.valid
                                    "
                                    class="premiumOfferIcon"
                                >
                                    {{ subCategory.premiumOffer.icon }}
                                </v-icon>
                            </div>
                        </v-col>
                        <v-col cols="2" v-else />

                        <v-col
                            cols="2"
                            v-if="
                                subCategory.trainingOffer &&
                                subCategory.trainingOffer.colorised &&
                                subCategory.trainingOffer.isEnd
                            "
                            class="pt-0 pb-0"
                        >
                            <div class="essentialOfferEndBackground d-flex justify-center ml-2">
                                <v-icon
                                    v-if="
                                        subCategory.trainingOffer && subCategory.trainingOffer.valid
                                    "
                                    class="essentialOfferIcon"
                                >
                                    {{ subCategory.trainingOffer.icon }}
                                </v-icon>
                            </div>
                        </v-col>
                        <v-col
                            cols="2"
                            v-else-if="
                                subCategory.trainingOffer && subCategory.trainingOffer.colorised
                            "
                            class="pt-0 pb-0"
                        >
                            <div class="essentialOfferBackground d-flex justify-center ml-2">
                                <v-icon
                                    v-if="
                                        subCategory.trainingOffer && subCategory.trainingOffer.valid
                                    "
                                    class="essentialOfferIcon"
                                >
                                    {{ subCategory.trainingOffer.icon }}
                                </v-icon>
                            </div>
                        </v-col>
                        <v-col cols="2" v-else />
                    </v-row>
                </template>
            </v-col>
        </v-row>
        <v-row dense v-if="isDisplayPrice">
            <v-col cols="6">
                <p class="d-flex justify-end pt-4">prix mensuel:</p>
            </v-col>
            <v-col cols="2">
                <p class="d-flex justify-center pt-4">{{ basicPrice }}&#x20ac;*</p>
            </v-col>
            <v-col cols="2">
                <p class="d-flex justify-center pt-4">{{ essentialPrice }}&#x20ac;*</p>
            </v-col>
            <v-col cols="2">
                <p class="d-flex justify-center pt-4">{{ premiumPrice }}&#x20ac;*</p>
            </v-col>
            <v-col cols="2">
                <p class="d-flex justify-center pt-4">{{ trainingPrice }}&#x20ac;*</p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
type Price_Type = {
    price: number;
    offer: Offer_type;
    discount: number;
};
import accountingOfferScheme from "@/assets/json/accountingOfferScheme.json";

import { Offer_type } from "@/types/offer.types";

import GET_BOBBEE_PRICES from "@/graphql/bobbeePriceList/GetBobbeePrices.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class AccountingOffer extends Vue {
    @Prop({ default: "55vh" }) heightMax: string;
    @Prop({ default: false }) isDisplayPrice: boolean;

    scheme: any = accountingOfferScheme;
    prices: Price_Type[] = [];

    getOfferType(offer) {
        switch (offer) {
            case "ACCOUNTING_STARTER":
                return Offer_type.ACCOUNTING_STARTER;
            case "ACCOUNTING_BASIC":
                return Offer_type.ACCOUNTING_BASIC;
            case "ACCOUNTING_ESSENTIAL":
                return Offer_type.ACCOUNTING_ESSENTIAL;
            case "ACCOUNTING_PREMIUM":
                return Offer_type.ACCOUNTING_PREMIUM;
            case "BUSINESS_BASIC":
                return Offer_type.BUSINESS_BASIC;
            case "BUSINESS_SMART":
                return Offer_type.BUSINESS_SMART;
            case "BUSINESS_ESSENTIAL":
                return Offer_type.BUSINESS_ESSENTIAL;
            case "BUSINESS_PREMIUM":
                return Offer_type.BUSINESS_PREMIUM;
        }
    }

    async beforeMount() {
        debugger;
        if (this.$store.state?.selected_company?.id) {
            const result = await this.$apollo.query({
                query: GET_BOBBEE_PRICES,
                variables: {
                    companyId: this.$store.state.selected_company.id,
                },
            });
            const bobbeePrice = result.data.getBobbeePrices.prices;
            for (const price of bobbeePrice.prices) {
                const discount =
                    (bobbeePrice.discount ? bobbeePrice.discount : 0) +
                    (price.discount ? price.discount : 0);
                const unitPrice = price.unitPrice * ((100 - discount) / 100);
                const offer = this.getOfferType(price.offer);
                const tmpPrice: Price_Type = { price: unitPrice, offer: offer, discount: discount };
                this.prices.push(tmpPrice);
            }
        }
    }

    get starterPrice() {
        for (const price of this.prices) {
            if (price.offer == Offer_type.ACCOUNTING_STARTER) return price.price;
        }
        return "0";
    }

    get basicPrice() {
        for (const price of this.prices) {
            if (price.offer == Offer_type.ACCOUNTING_BASIC) return price.price;
        }
        return "0";
    }

    get essentialPrice() {
        for (const price of this.prices) {
            if (price.offer == Offer_type.ACCOUNTING_ESSENTIAL) return price.price;
        }
        return "0";
    }

    get premiumPrice() {
        for (const price of this.prices) {
            if (price.offer == Offer_type.ACCOUNTING_PREMIUM) return price.price;
        }
        return "0";
    }

    get trainingPrice() {
        for (const price of this.prices) {
            if (price.offer == Offer_type.TRAINING) return price.price;
        }
        return "0";
    }

    get accountingLinePrice() {
        for (const price of this.prices) {
            if (this.$store.state.offerType == price.offer) {
                return 10 * ((100 - price.discount) / 100);
            }
        }
        return 10;
    }
}

export default toNative(AccountingOffer);
</script>

<style lang="css" scoped src="../../assets/style/accountingOfferStyle.css"></style>
